var render = function render(){var _vm=this,_c=_vm._self._c;return _c("detail",{tag:"div"},[_c('div',_vm._l((_vm.categories),function(category,key){return _c('Items',{key:key,attrs:{"category":category,"categoryID":key,"id":"viewMore"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }